import { useQueries } from "@tanstack/react-query";
import MarkdownRenderer from "../markdown/MarkdownRenderer";
import { fetchBlogImageUrl } from "../../utils/apiUtils";
import { extractS3Keys, replaceBlogImageSrc } from "./blogMedia.js";

const BlogHtmlBody = ({ html }) => {
    const keys = extractS3Keys(html);
    const results = useQueries({
        queries: keys.map((key) => ({
            queryKey: ["blog-image", key],
            queryFn: () => fetchBlogImageUrl(key),
            enabled: Boolean(key),
        })),
    });
    const urls = {};
    keys.forEach((key, index) => {
        if (results[index]?.data?.url) urls[key] = results[index].data.url;
    });
    return <MarkdownRenderer>{replaceBlogImageSrc(html, urls)}</MarkdownRenderer>;
};

export default BlogHtmlBody;
